import axios from 'axios';
import {API} from "@/services/url";

export default {
	createDeliveryReceipt : function (data, success, error) {
		axios.post(API.deliveryDetails.create, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getDeliveryDetails : function (purchaseOrderId, success, error) {
		axios.get(API.deliveryDetails.getByPurchaseOrderId + purchaseOrderId)
			.then(r => success(r.data.deliveredDevices))
			.catch(e => error(e.response.data.message));
	},
	replaceDevice : function (data, success, error) {
		axios.post(API.deliveryDetails.replace, data)
			.then(r => success(r.data.deliveredDevices))
			.catch(e => error(e.response.data.message));
	},
	downloadDeliveryReceipt : function (purchaseOrderId, success, error) {
		axios.get(API.deliveryDetails.downloadDeliveryReceipt + purchaseOrderId, {
			responseType : "blob"
		})
			.then(r => {
				let fileURL = window.URL.createObjectURL(new Blob([r.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'delivery-receipt.pdf');
				document.body.appendChild(fileLink);

				fileLink.click();
			})
			.catch(e => error(e));
	},
	updateDeliveryDetails   : function (deliveryDetailsId, data, success, error) {
		axios.post(API.deliveryDetails.update + deliveryDetailsId, data)
			.then(r => success(r))
			.catch(e => error(e));
	}
}
